import SnackbarMessageHandler from "@/general/component/snackbar/SnackbarMessageHandler";
import { AxiosResponse } from "axios";
import { Nullable, VForm } from "@/general/custom-types/CustomTypes";
import Component, { mixins } from "vue-class-component";
import { Watch } from "vue-property-decorator";

@Component({})
export default class Form<C, F, M> extends mixins(SnackbarMessageHandler) {
  submitting: boolean = false;
  model: Nullable<F>;

  get form() {
    return this.$refs.form as VForm;
  }

  async submit(): Promise<void> {
    this.submitting = true;
    try {
      const cmd: C = this.buildCmd();
      const response: M = await this.submitApi(cmd);
      await this.navigateAfterResponse(response);
    } catch (e) {
      this.setErrors(e);
      const errors = this.preFormatErrors(e);
      if (errors.data) {
        // do rozbicia na mniejsze fragmenty
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const keys = Object.entries(errors.data).map(([key, value]) => key);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (keys.length > 0 && this?.$refs?.form?.refs[keys[0]] !== undefined) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this?.$refs?.form?.refs[keys[0]].$el.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
        } else {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.showErrorSnackbar(errors);
        }
      }
    }
    this.submitting = false;
  }

  async submitApi(cmd: C): Promise<M> {
    throw new NotImplementedError();
  }

  buildCmd(): C {
    throw new NotImplementedError();
  }
  //TODO: REFAKTOR NA REDIRECTROUTE, NIE ZAWSZE CHCEMY NAWIGOWAĆ DO SHOW PO ZAPISANIU.
  // WYDAJE MI SIE, ŻE PRZYPADEK PRZEKIEROWANIA NA LISTĘ BĘDZIE RÓWNIEŻ WYKORZYSTYWANY
  showRoute(id: number): Record<string, unknown> {
    throw new NotImplementedError();
  }

  async navigateAfterResponse(model: M): Promise<void> {
    if (model) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const route: Record<string, unknown> = this.showRoute(model.id);
      if (this.$router) {
        await this.$router.push(route);
      }
    }
  }

  goBack(): void {
    if (this.$router) {
      this.$router.back();
    }
  }

  setErrors(errors: AxiosResponse): void {
    if (errors && this.$refs.form) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.$refs.form.setErrors(errors?.response?.data);
    }
  }

  preFormatErrors(errors: AxiosResponse): AxiosResponse {
    return errors;
  }

  @Watch("model")
  async handler() {
    await this.$nextTick();
    if (this.form) {
      this.form.validate();
    }
  }
}
